module.exports = __webpack_public_path__ + "img/alarm.552d9559.svg";